import React from "react";

const PrivacyPolicy = () => (
  <div style={{ padding: "2rem", maxWidth: 800, margin: "2rem auto" }}>
    <h1>BotFrens Privacy Policy</h1>
    <p>
      <strong>Last Updated:</strong> June 28, 2025
    </p>
    <p>
      BotFrens.com ("we," "us," or "our") respects your privacy. This Privacy
      Policy explains how we collect, use, and protect your information when you
      use our website and services.
    </p>
    <h2>1. Information We Collect</h2>
    <h3>a. Information You Provide</h3>
    <ul>
      <li>
        Email address and other contact info (e.g., via forms or account
        registration)
      </li>
      <li>Messages or content submitted via chat or other user input</li>
    </ul>
    <h3>b. Automatically Collected Data</h3>
    <ul>
      <li>IP address, browser type, OS, referring URLs</li>
      <li>Usage data (e.g., page views, time on site)</li>
      <li>Cookies and similar technologies</li>
    </ul>
    <h2>2. How We Use Your Information</h2>
    <ul>
      <li>Provide and improve our services</li>
      <li>Communicate with you (e.g., updates, support)</li>
      <li>Analyze site usage and enhance performance</li>
      <li>Ensure security and prevent abuse</li>
    </ul>
    <p>
      <strong>We do not sell your personal data.</strong>
    </p>
    <h2>3. Sharing of Information</h2>
    <ul>
      <li>
        Trusted service providers under confidentiality agreements (e.g.,
        hosting, analytics)
      </li>
      <li>Legal authorities if required by law or to protect our rights</li>
      <li>
        Other users if you explicitly choose to share data (e.g., in public
        forums or chat)
      </li>
    </ul>
    <h2>4. Your Rights & Choices</h2>
    <ul>
      <li>
        <strong>Access/Correction:</strong> Contact us to review or update your
        data
      </li>
      <li>
        <strong>Opt-Out:</strong> You may unsubscribe from communications at any
        time
      </li>
      <li>
        <strong>Cookies:</strong> You can control cookie settings in your
        browser
      </li>
    </ul>
    <h2>5. Data Retention</h2>
    <p>
      We retain personal data only as long as needed for its purpose or as
      required by law.
    </p>
    <h2>6. Security</h2>
    <p>
      We implement reasonable measures to protect your information but cannot
      guarantee absolute security.
    </p>
    <h2>7. Children's Privacy</h2>
    <p>
      Our services are not intended for children under 13. We do not knowingly
      collect data from them.
    </p>
    <h2>8. International Users</h2>
    <p>
      By using our services, you consent to your data being transferred to and
      processed in the United States.
    </p>
    <h2>9. Changes to This Policy</h2>
    <p>
      We may update this policy. Material changes will be announced via the site
      or email.
    </p>
    <h2>10. Contact</h2>
    <p>
      For questions, contact us at:{" "}
      <a href="mailto:support@botfrens.com">support@botfrens.com</a>
    </p>
  </div>
);

export default PrivacyPolicy;
